{
  "INBOX": {
    "LIST": {
      "TITLE": "My Inbox",
      "DISPLAY_DROPDOWN": "Відобразити",
      "LOADING": "Завантаження сповіщень",
      "404": "Немає активних сповіщень у цій групі.",
      "NO_NOTIFICATIONS": "Немає сповіщень",
      "NOTE": "Сповіщення від усіх підписок на вхідні повідомлення",
      "NO_MESSAGES_AVAILABLE": "Ой! Не вдалося отримати повідомлення",
      "SNOOZED_UNTIL": "Відкладено до",
      "SNOOZED_UNTIL_TOMORROW": "Відкладено до завтра",
      "SNOOZED_UNTIL_NEXT_WEEK": "Відкладено до наступного тижня"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Відключити сповіщення",
      "DELETE": "Видалити сповіщення",
      "BACK": "Назад"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Ви були згадані в розмові",
      "CONVERSATION_CREATION": "Діалог створено",
      "CONVERSATION_ASSIGNMENT": "Розмова була призначена для вас",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Нове повідомлення в призначеній розмові",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Нове повідомлення в розмові, в якій ви берете участь",
      "SLA_MISSED_FIRST_RESPONSE": "Перша відповідь на SLA пропущена для розмови",
      "SLA_MISSED_NEXT_RESPONSE": "Запропонована відповідь SLA відсутня для розмови",
      "SLA_MISSED_RESOLUTION": "Цільова роздільна здатність SLA відсутня для розмови"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Mentioned",
      "CONVERSATION_ASSIGNMENT": "Assigned to you",
      "CONVERSATION_CREATION": "New Conversation",
      "SLA_MISSED_FIRST_RESPONSE": "SLA breach",
      "SLA_MISSED_NEXT_RESPONSE": "SLA breach",
      "SLA_MISSED_RESOLUTION": "SLA breach",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Нове повідомлення",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Нове повідомлення",
      "SNOOZED_UNTIL": "Snoozed for {time}",
      "SNOOZED_ENDS": "Snooze ended"
    },
    "NO_CONTENT": "Немає вмісту",
    "MENU_ITEM": {
      "MARK_AS_READ": "Позначити як прочитане",
      "MARK_AS_UNREAD": "Позначити як непрочитане",
      "SNOOZE": "Відкласти",
      "DELETE": "Видалити",
      "MARK_ALL_READ": "Позначити всі як прочитані",
      "DELETE_ALL": "Видалити все",
      "DELETE_ALL_READ": "Видалити всі прочитані"
    },
    "DISPLAY_MENU": {
      "SORT": "Сортувати",
      "DISPLAY": "Відобразити :",
      "SORT_OPTIONS": {
        "NEWEST": "Новіші",
        "OLDEST": "Старіші",
        "PRIORITY": "Пріоритет"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Відкладено",
        "READ": "Прочитано",
        "LABELS": "Мітки",
        "CONVERSATION_ID": "ID бесіди"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Повідомлення помічено як прочитане",
      "MARK_AS_UNREAD": "Повідомлення помічено як непрочитане",
      "SNOOZE": "Сповіщення відключено",
      "DELETE": "Сповіщення видалено",
      "MARK_ALL_READ": "Повідомлення помічено як прочитане",
      "DELETE_ALL": "Сповіщення видалено",
      "DELETE_ALL_READ": "Всі прочитані повідомлення видалено"
    },
    "REAUTHORIZE": {
      "TITLE": "Reauthorization Required",
      "DESCRIPTION": "Your WhatsApp connection has expired. Please reconnect to continue receiving and sending messages.",
      "BUTTON_TEXT": "Reconnect WhatsApp",
      "LOADING_FACEBOOK": "Loading Facebook SDK...",
      "SUCCESS": "WhatsApp reconnected successfully",
      "ERROR": "Failed to reconnect WhatsApp. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "CONFIGURATION_ERROR": "Configuration error occurred during reauthorization.",
      "FACEBOOK_LOAD_ERROR": "Failed to load Facebook SDK. Please try again.",
      "TROUBLESHOOTING": {
        "TITLE": "Troubleshooting",
        "POPUP_BLOCKED": "Ensure pop-ups are allowed for this site",
        "COOKIES": "Third-party cookies must be enabled",
        "ADMIN_ACCESS": "You need admin access to the WhatsApp Business Account"
      }
    }
  }
}
